import { useEffect } from 'react'
import styles from './FilterPanel.module.css'

/** The 4 real Google Ad Manager (GPT) 300x250 slots that used to live in the legacy
 *  events/index.cfm's right sidebar ("Site Sponsors" + "Advertisements" cards in
 *  webshared/includes/_right_side_bar_default.cfm), now in this page's left filter rail
 *  instead. Order matches that legacy DOM order exactly. The slots themselves are defined
 *  (googletag.defineSlot) server-side in events/index.cfm, inside the same
 *  non-localhost / ads-not-disabled-for-this-viewer gate _header.cfm uses - this component
 *  only displays into divs that bootstrap already expects to exist. */
const SPONSOR_AD_IDS = [
  'div-gpt-ad-1736199318646-0',
  'div-gpt-ad-1736542217692-0',
  'div-gpt-ad-1711120147714-0',
  'div-gpt-ad-1735361515427-0',
]

export function SponsorAds() {
  const adsEnabled = window.__GOOGLE_ADS_ENABLED__ === true

  useEffect(() => {
    if (!adsEnabled || !window.googletag) return
    for (const id of SPONSOR_AD_IDS) {
      window.googletag.cmd.push(() => window.googletag!.display(id))
    }
    // Slots are defined once in events/index.cfm and never change - only display them once,
    // on mount, same as a static page's inline <script> would have.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!adsEnabled) {
    return <div className={styles.sponsorSlot}>Sponsor slot · 300 × 250</div>
  }

  return (
    <div className={styles.adStack}>
      {SPONSOR_AD_IDS.map((id) => (
        <div key={id} id={id} className={styles.adSlot} />
      ))}
    </div>
  )
}
